module.exports = __webpack_public_path__ + "files/ca4d226c2c041ce9d9e946e7f7eb297e.woff2";


//////////////////
// WEBPACK FOOTER
// ./fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-600italic.woff2
// module id = 1112
// module chunks = 60